import { gql } from "@apollo/client";

// export const GET_STUDENTS_STASTISTICS = gql`
//   query GetStudentsStatistics($academicYear: String!, $programme: String!) {
//     getStudentsStatistics(academicYear: $academicYear, programme: $programme) {
//       programme
//       classGroup {
//         classGroupName
//         F
//         M
//         totalStu
//       }
//     }
//   }
// `;

export const GET_ALL_STUDENT = gql`
  query GetStudents($keyword: String!) {
    getStudents(keyword: $keyword) {
      _id
      student_id
      profileImg
      englishName
      currentAddress
      lastName
      gender
      dob
      firstName
      idCard
    }
  }
`;

export const GET_STUDENTS_FOR_SELECT = gql`
  query GetStudentsForSelect {
    getStudentsForSelect {
      _id
      englishName
      profileImg
    }
  }
`;

export const GET_STUDENT_ENROLLMENT = gql`
  query GetStudentEnrollments($studentId: ID!) {
    getStudentEnrollments(studentId: $studentId) {
      _id
      enrollments {
        _id
        programId {
          _id
          programmName
          programmNameEn
        }
        academicYearId {
          _id
          academicYear
          academicYearInKhmer
        }
        shiftId {
          _id
          shiftName
          note
        }
        gradeId {
          _id
          gradeName
        }
        startDate
        classId {
          _id
          className
        }
      }
    }
  }
`;

// export const GET_STUDENT_BY_ID = gql`
//   query GetPersonalInfoByID($id: String!) {
//     getPersonalInfoByID(_id: $id) {
//       data {
//         _id
//         firstName
//         lastName
//         englishName
//       }
//       message
//       status
//     }
//   }
// `;

export const GET_STUDENT_BY_ID = gql`
  query GetStudentById($id: ID) {
    getStudentById(_id: $id) {
      _id
      firstName
      lastName
      englishName
      nickName
      gender
      nationality
      profileImg
      village
      commune
      district
      province
      dob
      remark
      guardian {
        _id
        firstName
        lastName
        englishName
        nickName
        gender
        nationality
        khmerId
        profileImg
        village
        commune
        district
        province
        dob
        remark
        customerType
        religion
        passportNumber
        permanentVillage
        permanentCommune
        permanentDistrict
        permanentProvince
        permanentCountry
        social
        email
        tel
        occupation
        education
        createdAt
      }
      mother {
        _id
        firstName
        lastName
        englishName
        nickName
        gender
        nationality
        khmerId
        profileImg
        village
        commune
        district
        province
        dob
        remark
        customerType
        religion
        passportNumber
        permanentVillage
        permanentCommune
        permanentDistrict
        permanentProvince
        permanentCountry
        social
        email
        tel
        occupation
        education
        createdAt
      }
      father {
        _id
        firstName
        lastName
        englishName
        nickName
        gender
        nationality
        khmerId
        profileImg
        village
        commune
        district
        province
        dob
        remark
        customerType
        religion
        passportNumber
        permanentVillage
        permanentCommune
        permanentDistrict
        permanentProvince
        permanentCountry
        social
        email
        tel
        occupation
        education
        createdAt
      }
      customerType
      bloodGroup
      student_id
      qrId
      joiningDate
      religion
      permanentVillage
      permanentCommune
      permanentDistrict
      permanentProvince
      permanentCountry
    }
  }
`;

export const GET_SCHOOL = gql`
  query GetSchools {
    getSchools {
      _id
      schoolName
    }
  }
`;
export const GET_GRADES = gql`
  query GetGrads($keyword: String, $programme: String) {
    getGrads(keyword: $keyword, programme: $programme) {
      _id
      gradeName
    }
  }
`;

export const GET_CLASSES = gql`
  query GetClassesNameByGrade($gradeId: String!) {
    getClassesNameByGrade(gradeId: $gradeId) {
      _id
      className
    }
  }
`;

export const GET_STUDENT_WITH_PAGINATION = gql`
  query GetStudentsWithPagination($page: Int, $limit: Int, $keyword: String) {
    getStudentsWithPagination(page: $page, limit: $limit, keyword: $keyword) {
      data {
        _id
        firstName
        lastName 
        englishName
        nickName
        gender
        nationality
        profileImg
        village
        commune
        district
        province
        dob
        remark
        guardian {
          _id
          englishName
          gender
          lastName
          firstName
        }
        mother {
          _id
          englishName
          gender
          lastName
          firstName
        }
        father {
          _id
          englishName
          gender
          lastName
          firstName
        }
        customerType
        bloodGroup
        student_id
        qrId
        joiningDate
        religion
        permanentVillage
        permanentCommune
        permanentDistrict
        permanentProvince
        permanentCountry
        createdAt
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const CREATE_STUDENT = gql`
  mutation CreateStudent($input: StudentInput!) {
    createStudent(input: $input) {
      status
      message
    }
  }
`;
export const UPDATE_STUDENT = gql`
  mutation UpdateStudent($input: StudentInput!, $id: ID!) {
    updateStudent(input: $input, _id: $id) {
      status
      message
    }
  }
`;

export const DELETE_STUDENT = gql`
  mutation DeleteStudent($id: ID!) {
    deleteStudent(_id: $id) {
      status
      message
    }
  }
`;

export const GET_PARENTS = gql`
  query GetParents($keyword: String) {
    getParents(keyword: $keyword) {
      _id
      firstName
      lastName
      englishName
      nickName
      gender
      nationality
      khmerId
      profileImg
      village
      commune
      district
      province
      dob
      remark
      customerType
      religion
      passportNumber
      permanentVillage
      permanentCommune
      permanentDistrict
      permanentProvince
      permanentCountry
      social
      email
      tel
      occupation
      education
    }
  }
`;

export const GET_STUDENT_ENROLLMENT_INFO = gql`
  query GetStudentEnrollmentInfo($id: ID!) {
    getStudentEnrollmentInfo(_id: $id) {
      studentName
      profileImg
      enroll {
        className
        programmeName
      }
    }
  }
`;



